import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarNotAuth from '../components/navbarNotAuth'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'

function Civita() {
    return (<>
        {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div style={{ marginTop: '6rem' }}></div>
        <App />
        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Civita di Bagnoregio</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>LAZIO
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>ARTE
                    </span>
                </h5>
            </div>

            {/* {foto && */}
            <div className='mt-1'>
                <div className='galleria container-fluid'>
                    <div className='gbox1'>
                        <img src={require('../image/gabriele-merlino-unsplash.jpg')}
                            height='100%' width='100%' alt='' />
                    </div>
                    <div className='gbox2'>
                        <h4>La città che muore</h4><hr />
                        <p className='mt-3'>
                            <b>Civita di Bagnoregio</b> è un borgo antico e pittoresco che si eleva
                            nel cuore della Tuscia Laziale (VT), nella Valle dei Calanchi.
                        </p>
                        <hr />
                        <p>
                            Purtroppo, con il passare degli anni, gli agenti atmosferici hanno provocato una forte erosione
                            del materiale argilloso e tufaceo che sorreggono il borgo stesso.<br />
                            Civita di Bagnoregio, quindi è destinata a sgretolarsi inesorabilmente. Per questo viene soprannominata <b>la città che muore. </b>
                            Il borgo emerge maestoso e pittoresco nella <b>valle dei calanchi</b> e si può raggiungere attraverso un lungo
                            ponte rigorosamente pedonale. Inutile dirvi quanto in quel percorso si goda di un panorama mozzafiato!
                            Una volta entrati si potrà ammirare la piazza principale dov'è ubicata la chiesa di
                            <b> San Donato</b> per poi immergersi nei vicoletti che ad ogni angolo regalano panorami e scorci da favola.
                            Solo pochi abitanti risiedono nel luogo, oramai totalmente turistico, ricco di B&B, ristoranti e negozietti.<br />
                            Un luogo magico e affascinante da non perdere.
                        </p>

                    </div>
                    <img src={require('../image/letian-zhang-k0JPXg26vus-unsplash.jpg')} className='galleria_immagine addImg' alt='' />
                    <img src={require('../image/tommao-wang-0yzPfH_lXQw-unsplash.jpg')} className='galleria_immagine addImg' alt='' />
                </div>

                <p className='m-3'>
                    <b>Civita di Bagnoregio</b> è classificata come uno dei <b>borghi più belli d'Italia</b> e solo attraverso un ponte
                    sospeso lungo 300 mt è possibile raggiungerla.
                    Per la sua particolarità è stato scelto da alcuni registi come location cinematografica.
                    Tra questi segnalo: 'I due colonnelli' con Totò del 1962,
                    'Contestazione generale' con Alberto Sordi, la fiction 'Pinocchio' del 2009 e il delizioso 'Questione di Karma'
                    con Fabio De Luigi ed Elio Germano.
                </p>

                <div className='container mt-2'>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>PINOCCHIO A CIVITA DI BAGNOREGIO</h1>
                        <img src={require('../image/jametlene-reskp-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <p className='mt-3'>
                            Dopo Farnese, località viterbese che fu teatro dell'indimenticabile Pinocchio di Comencini,
                            <b> Civita di Bagnoregio</b> fu scelta per la fiction in chiave moderna della famosa favola.
                            Questi luoghi suggestivi sono il perfetto contorno scenografico delle avventure del mitico burattino,
                            scelti per l'ennesima volta anche dal regista Alberto Sironi per la sua opera.<br />
                            Potrete anche ammirare, durante la famosa scena nel paese dei balocchi la zona archeologica di Sutri.<br />
                            Insomma la <b>Tuscia</b> è il luogo ideale per ritornare anche un pò bambini.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>IL PONTE SOSPESO</h1>
                        <img src={require('../image/bernardo-ferrari-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <p className='mt-3'>
                            L'unico collegamento del borgo con i paesi vicini e sottostanti è attraverso un ponte lungo 300 metri percorribile
                            solamente a piedi dal quale si gode un panorama mozzafiato, tra i più emozionanti del Lazio.<br />
                            Con la nebbia <b>Civita di Bagnoregio</b> sembra come ovattata e sospesa nel vuoto, un'immagine surreale.
                            Per la sua unicità è senza ombra di dubbio uno dei borghi italiani più belli.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>GASTRONOMIA</h1>
                        <img src={require('../image/heidi-kaden-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <p className='mt-3'>
                            Olio locale e prodotti tipici, come le nocciole, le castagne dei Monti Cimini e le erbe selvatiche
                            sono alla base dei piatti della Tuscia Laziale.<br />
                            Scopriamo le tipicità della cucina tradizionale viterbese così potete sapere cosa mangiare a Viterbo
                            e nei suoi dintorni in caso vi troviate li:<br />
                            <b><i>Lombrichelli alla vitorchianese, Frittelle di broccoli, Maccheroni con le noci, Ciambelle con l'anice, Castagnole alla Sambuca, Ravioli alla ricotta.</i></b>
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>COSA FARE A CIVITA DI BAGNOREGIO</h1>
                        <img src={require('../image/gabriele-merlino-unsplash.jpg')} className='imgCittà'
                            alt='' />
                        <br />
                        <ul className='mt-3 text-start'>
                            <li>
                                <b>Giardino del poeta</b>, uno spazio fiabesco molto suggestivo e panoramico che si affaccia sui calanchi.
                            </li>
                            <li>
                                <b>Museo geologico</b>, un'esperienza da non perdere se si vuole capire Civita, la sua storia e la sua conformazione.
                            </li>
                            <li>
                                <b>Chiesa di San Donato</b>, una bella chiesa nella piazza principale di Civita di bagnoregio.
                            </li>
                            <li>
                                <b>Antica Civitas</b>, un piccolo salto nel passato per apprezzare gli utensili utilizzati dalla tradizione contadina.
                            </li>
                            <li>
                                All'interno del borgo poi ci sono ristoranti, trattorie e bar ma anche bed & breakfast e negozi di <b>artigianato locale</b>.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* } */}

            <DivBottom />
        </div >
    </>
    )
}
export default Civita